angular.
module("dx.webapp.onlineResources").
directive("dxInputIcon", function inputIconDirective() {
	"use strict";

	return {
		restrict: "A",
		scope: {
			dxInputIcon: "@",
			dxInputIconToggle: "=",
			dxInputIconSize: "<",
		},
		link: link,
	};

	function link($scope, $element) {
		var img = angular.element("<img src='" + $scope.dxInputIcon + "' />");
		var input = $element.children("input");
		if ($scope.dxInputIconSize) {
			img.css("width", $scope.dxInputIconSize.width + "px");
			img.css("height", $scope.dxInputIconSize.height + "px");
		}
		img.css("position", "relative").css("top", "-26px").css("left", "8px");
		$element.append(img);

		//Based on the input field height from _input.scss and if changed this needs to change as well.
		$element.css("max-height", "calc(1.42857em + 12px)");

		input.addClass("input-icon");

		if ($scope.dxInputIconToggle) {
			$scope.dxInputIconToggle.toggledOn = true;
			$scope.dxInputIconToggle.toggle = function toggle() {
				if ($scope.dxInputIconToggle.toggledOn) {
					input.removeClass("input-icon");
					img.hide();
					$scope.dxInputIconToggle.toggledOn = false;
				} else {
					$scope.dxInputIconToggle.toggledOn = true;
					input.addClass("input-icon");
					img.show();
				}
			};
		}
	}
});
